// Libraries
import styled from "styled-components";

export const SXEmptyContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 60rem;
  margin: 8rem auto;
`;

export const SXLottie = styled.div`
  display: flex;
  width: 20rem;
  height: 20rem;
  margin-bottom: 2rem;

  svg {
    width: inherit;
    height: inherit;
  }
`;
